import React, { Component } from 'react'
import { MDBContainer, MDBAlert,  MDBTable, MDBTableBody, MDBTableHead, MDBBtn, MDBRow, MDBCol, MDBIcon  } from 'mdbreact';
import {  MDBTabPane, MDBTabContent, MDBNav, MDBNavItem, MDBNavLink } from "mdbreact";
import Axios from 'axios'
import { Steps, Alert  } from 'antd';
import { Chart } from "react-google-charts";

import adminfaculty from '../adminfaculty/adminfaculty';
import Modalarticletyps from './Modalarticletypes';
import Modalcertificate from './Modalcertificate';




export default class superadmincertificate extends Component {

    constructor(props) {
        super(props);
        this.state = {
          articlesci1:[],
          articlehum1:[],
          articlesci2:[],
          articlehum2:[],
          article2:[],
          certificate:[],
          activeItem: "1"
        };
        // this.handleChange = this.handleChange.bind(this);
        // this.handleChange2 = this.handleChange2.bind(this);
         this.updateat = this.updateat.bind(this);
      }


      toggle = tab => e => {
        if (this.state.activeItem !== tab) {
          this.setState({
            activeItem: tab
          });
        }
      };


    componentDidMount() {

        // const token = JSON.parse(localStorage.getItem('nameuser'));
        if (localStorage.getItem('nameuser') == null) {
            window.location.href = '/'
        } else {
    
        }

        setTimeout(() => {
           //ภายใน
            Axios.get('https://edu.kpru.ac.th/conference/PHPAPI/selectreportcf.php')
           .then(res => {
             console.log(res);
           //  this.setState({ bankname: res.data, loading: false })
             this.setState({ certificate: res.data})
           }) 
         }, 0);

      }
      

      updateat(){
        setTimeout(() => {
           
          Axios.get('https://edu.kpru.ac.th/conference/PHPAPI/selectarticle1.php')
         .then(res => {
           console.log(res);
         //  this.setState({ bankname: res.data, loading: false })
           this.setState({ article: res.data})
         }) 

         Axios.get('https://edu.kpru.ac.th/conference/PHPAPI/selectarticle2.php')
         .then(res => {
           console.log(res);
         //  this.setState({ bankname: res.data, loading: false })
           this.setState({ article2: res.data})
         }) 

       }, 0);
      }



    render() {
        const { Step } = Steps;
        return (
            <MDBContainer >
            <div>
            <p className="text-right">สวัสดีคุณ : {localStorage.getItem('nameuser')}</p>
            <p className="text-right">การประชุมวิชาการระดับชาติครุศาสตร์ศึกษา ครั้งที่ 8 มหาวิทยาลัยราชภัฏกำแพงเพชร(ผู้ดูแลระบบกลาง)</p> 
         
               <MDBAlert color="success" >
                   <h2><MDBIcon icon="file-signature" /> จัดการเกียรติบัตร</h2>
                </MDBAlert>

                <MDBTable>
                    <MDBTableHead>
                        <tr>
                        <th>ลำดับ</th>
                        <th>ชื่อเรื่อง</th>
                        <th>สาขา</th>
                        <th>จัดการ</th>
                        </tr>
                    </MDBTableHead>

                    <MDBTableBody>
                    {this.state.certificate.map((certificate,index )  => 
                        <tr>
                        <td>{index+1}</td>
                        <td>{certificate.send_name}</td>
                        <td>{certificate.major_precent}</td>
                        
                        <td className="text-center">  { certificate.id_sendcf == null ? <> <Modalcertificate  id_send={certificate.id_send} namearticla={certificate.send_name} branchcf={certificate.major_precent} /> </>:<> <MDBBtn color="secondary" size="sm" href={'https://conference.kpru.ac.th/PHPAPI/TCPDF-main/certificate.php?id_sendcf='+certificate.id_sendcf } target="_blank"> ตัวอย่างเกียรติบัตร</MDBBtn>  </> } </td>
                        </tr>
                    )}
                    </MDBTableBody>
             </MDBTable>

            </div>
            </MDBContainer>
        )
    }
}
